import Banner from "../components/Banner";
import galeria_premios from "../assets/premios.jpg";
import compromiso from "../assets/compromiso.svg";
import argollas from "../assets/argollas.svg";
import banquete from "../assets/banquete.svg";
import dj from "../assets/DJ.svg";
import arregloFloral from "../assets/arregloflores.svg";
import vinoBebida from "../assets/vino.svg"
import pastel from "../assets/pastel.svg";
import fotoVideo from "../assets/fotoyvideo.svg";
import invitaciones from "../assets/invitaciones.svg";
import ajuar from "../assets/ajuar.svg";
import maquillajePeinado from "../assets/peinado-maquillaje.svg";
import lunaMiel from "../assets/lunamiel.svg";
import Esmoquin from "../assets/esmokin.svg";
import coche from "../assets/coche.svg";
import articuloHogar from "../assets/articulos.svg";
import preluna from "../assets/pre-luna.svg";
import colchon from "../assets/colchon.svg";

const Premios = () => {
  const contenidoBanner = {
    titulo: "Premios",
    texto:
      "Ya saben que todo me gusta de primera y en abundancia, por eso para que tengan la mejor boda del 2022, tenemos listo desde el vestido hasta la luna de miel, más todos estos regalos.",
    imagen: galeria_premios,
  };

  return (
    <>
        {/* <div className="containerTelon">
          <div className="telon"></div>
        </div> */}
      <Banner contenidoBanner={contenidoBanner} />
      <div className="global__container container marginPremiosCard">
        <div className="row py-5">

          <div className="col-12 col-sm-4 col-md-3 px-4 py-sm-4 py-5">
            <img class="img-fluid imgPremios" src={compromiso} alt="Anillos de Boda"/>
            <p className="text-center pt-3 h5">Anillos de boda</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
            <img class="img-fluid imgPremios" src={argollas} alt="Argollas"/>
            <p className="text-center pt-3 h5">Argollas</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={banquete} alt="Banquete"/>
            <p className="text-center pt-3 h5">Banquete</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={dj} alt="DJ"/>
            <p className="text-center pt-3 h5">DJ</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={arregloFloral} alt="Arreglo floral"/>
            <p className="text-center pt-3 h5">Decoración floral</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={vinoBebida} alt="Vino y bebidas"/>
            <p className="text-center pt-3 h5">Vino y licores</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={pastel} alt="Pastel"/>
            <p className="text-center pt-3 h5">Pastel</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={fotoVideo} alt="Foto y video"/>
            <p className="text-center pt-3 h5">Fotografía y video</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={invitaciones} alt="Invitaciones"/>
            <p className="text-center pt-3 h5">Invitaciones</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={ajuar} alt="Ajuar"/>
            <p className="text-center pt-3 h5">Ajuar</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={maquillajePeinado} alt="Maquillaje y peinado"/>
            <p className="text-center pt-3 h5">Maquillaje y peinado para la novia y las mamás de los novios</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={lunaMiel} alt="Luna de miel"/>
            <p className="text-center pt-3 h5">Luna de miel</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={Esmoquin} alt="Esmoquin"/>
            <p className="text-center pt-3 h5">Renta de esmoquin para el novio y para los papás de los novios</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={coche} alt="Coche"/>
            <p className="text-center pt-3 h5">Coche</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={articuloHogar} alt="Artículo para el hogar"/>
            <p className="text-center pt-3 h5">Artículos para el hogar</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={colchon} alt="Colchon"/>
            <p className="text-center pt-3 h5">Colchón</p>
          </div>
          <div className="col-12 col-sm-4 col-md-3 px-3 py-sm-4 py-5">
          <img class="img-fluid imgPremios" src={preluna} alt="Pre-luna"/>
            <p className="text-center pt-3 h5">Pre-luna de miel</p>
          </div>

        </div>
      </div>
    </>
  );
};

export default Premios;
